import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QueryHandler } from '@/app/tracking/common';
import { QueryExamResultsTrackingQuery, QueryExamResultsTrackingQueryPayload } from '../api'
import { ExamSuspendDataStore } from '../common';

const debug = Debug('xapi-query-exam-results-query-handler')

@injectable()
export class XApiQueryExamResultsQueryHandler implements QueryHandler<QueryExamResultsTrackingQuery> {

  constructor (
    @inject(ExamSuspendDataStore)
    private examStore: ExamSuspendDataStore,
  ) {}
  
  public async execute(query: QueryExamResultsTrackingQueryPayload) {

    debug('execute', query)

    const exams = await this.examStore.query('all')

    debug('exams', exams)

    return {
      exams
    }
  }
}
